import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Product from '../views/Product.vue'
import Regions from '../views/Regions.vue'
import Statistics from '../views/Statistics.vue'
import Error404 from '../views/Error404.vue'

import store from '../store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [

  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/product/:model',
    name: 'product',
    component: Product,
    props: true
  },
  {
    path: '/regions',
    name: 'regions',
    component: Regions
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: Statistics
  },
  {
    path: '/compare/:comparison',
    name: 'compare',
    component: Statistics,
    props: true
  },
  {
    path: '/:locale/*',
    redirect (to) {
      if (['en', 'sv'].includes(to.params.locale)) {
        store.dispatch('changeLocale', to.params.locale)
      }
      return to.params.pathMatch
    }
  },
  {
    path: '*',
    name: '404',
    component: Error404
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
